import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServicesBento } from "@/components/home/ServicesBento";
import { Sectors } from "@/components/home/Sectors";
import { Legacy } from "@/components/home/Legacy";
import { Process } from "@/components/home/Process";
import { Faq } from "@/components/home/Faq";
import { Projects } from "@/components/home/Projects";
import { AreasStrip } from "@/components/home/AreasStrip";
import { CtaBand } from "@/components/site/CtaBand";

export default function Home() {
  return (
    <>
      <Seo title="Austyle Plumbing – Sydney Plumbers for Homes, Strata & Builds"
        description="Austyle Plumbing – Sydney plumbers with 30 years' experience in domestic, commercial and industrial plumbing, new builds, strata and maintenance. Book online." />
      <Hero />
      <Marquee items={["New builds", "Strata", "Maintenance", "Domestic", "Commercial", "Industrial"]} />
      <ServicesBento />
      <Sectors />
      <Projects />
      <Legacy />
      <AreasStrip />
      <Process />
      <Faq />
      <CtaBand />
    </>
  );
}
